export interface FileRestrictions {
  maxFiles?: number;
  maxSize?: number;
  accept?: string[];
}

export enum ErrorCode {
  FileInvalidType,
  FileTooLarge,
  TooManyFiles,
}

const getBaseMimeType = (mimeType: string) => {
  return mimeType.split(';')[0].trim();
};

export const validateFiles = (files: File[], restrictions: FileRestrictions) => {
  const { maxFiles, maxSize, accept } = restrictions;
  const errorCodes = new Set<ErrorCode>();
  const acceptedFiles: File[] = [];

  files.forEach((file) => {
    const invalidFileSize = maxSize !== undefined && file.size > maxSize;

    /* prettier-ignore */
    const invalidFileType = accept?.length && !accept.some((type) => {
      if (type.endsWith('*')) {
        return file.type.startsWith(type.slice(0, -1));
      }
    
      if (type.startsWith('.')) {
        return file.name.toLowerCase().endsWith(type);
      }
    
      const baseType = getBaseMimeType(type);
      const baseFileType = getBaseMimeType(file.type);
    
      return baseFileType === baseType;
    });

    if (invalidFileSize) {
      errorCodes.add(ErrorCode.FileTooLarge);
    }

    if (invalidFileType) {
      errorCodes.add(ErrorCode.FileInvalidType);
    }

    if (!invalidFileSize && !invalidFileType) {
      acceptedFiles.push(file);
    }
  });

  const maxFilesLimitExceeded = maxFiles !== undefined && acceptedFiles.length > maxFiles;

  if (maxFilesLimitExceeded) {
    errorCodes.add(ErrorCode.TooManyFiles);
    acceptedFiles.splice(maxFiles);
  }

  return { acceptedFiles, errorCodes };
};
